// Страницы внутри AppLayout. Router оборачивает загрузчики в lazy, а AppLayout
// подгружает их в простое: первый переход в раздел не ждёт загрузки чанка.
export const loadDashboardPage = () => import('@/pages/dashboard/DashboardPage/DashboardPage.js');
export const loadProjectListPage = () =>
  import('@/pages/projects/ProjectListPage/ProjectListPage.js');
export const loadProjectDetailPage = () =>
  import('@/pages/projects/ProjectDetailPage/ProjectDetailPage.js');
export const loadProjectCreatePage = () =>
  import('@/pages/projects/ProjectCreatePage/ProjectCreatePage.js');
export const loadChatPage = () => import('@/pages/chat/ChatPage/ChatPage.js');
export const loadTaskSelectPage = () => import('@/pages/tasks/TaskSelectPage/TaskSelectPage.js');
export const loadTaskBoardPage = () => import('@/pages/tasks/TaskBoardPage/TaskBoardPage.js');
export const loadCalculatorIndexPage = () => import('@/routes/calculator/index.js');
export const loadCalculatorPage = () => import('@/routes/calculator/[slug].js');
export const loadRatesPage = () => import('@/pages/rates/RatesPage/RatesPage.js');
export const loadMaterialsPage = () => import('@/pages/materials/MaterialsPage/MaterialsPage.js');
export const loadTeamsPage = () => import('@/pages/teams/TeamsPage/TeamsPage.js');
export const loadTeamDetailPage = () => import('@/pages/teams/TeamDetailPage/TeamDetailPage.js');
export const loadProfilePage = () => import('@/pages/profile/ProfilePage/ProfilePage.js');
export const loadTemplatesIndexPage = () => import('@/routes/templates/index.js');
export const loadTemplateDetailPage = () => import('@/routes/templates/[id].js');
export const loadBrandingSettingsPage = () => import('@/routes/settings/branding.js');

// Сначала разделы меню, потом страницы, куда попадают из них.
const PRELOAD_ORDER = [
  loadDashboardPage,
  loadProjectListPage,
  loadChatPage,
  loadTaskSelectPage,
  loadCalculatorIndexPage,
  loadRatesPage,
  loadMaterialsPage,
  loadTeamsPage,
  loadProfilePage,
  loadProjectDetailPage,
  loadTaskBoardPage,
  loadCalculatorPage,
  loadProjectCreatePage,
  loadTeamDetailPage,
  loadTemplatesIndexPage,
  loadTemplateDetailPage,
  loadBrandingSettingsPage,
];

let preloadStarted = false;

function whenIdle(cb: () => void) {
  // В Safari requestIdleCallback нет.
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(cb, { timeout: 3000 });
  } else {
    setTimeout(cb, 300);
  }
}

export function preloadAppRouteModules(): void {
  if (preloadStarted) return;
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection;
  // Без сети упавший import() запоминается браузером и сломал бы будущий переход.
  if (!navigator.onLine || connection?.saveData) return;
  preloadStarted = true;
  const queue = [...PRELOAD_ORDER];
  const next = () => {
    const load = queue.shift();
    if (!load) return;
    // По одному чанку за раз, чтобы не отнимать сеть у текущей страницы.
    load()
      .catch(() => undefined)
      .finally(() => whenIdle(next));
  };
  whenIdle(next);
}
